@if (progress>=100) {
<span><b>YOU'VE EARNED FREE SHIPPING!</b></span>
}@else{
<span>YOU'RE <b>${{left}}</b> AWAY FROM FREE SHIPPING!</span>
}
<div class="progress">
  <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
  @if (progress<100) {
  <mat-icon fontSet="material-symbols-outlined">
    delivery_truck_speed
  </mat-icon>
  }@else{
  <mat-icon
    fontSet="material-symbols-outlined"
    style="font-variation-settings: 'FILL' 1; color: var(--mat-sys-primary)"
  >
    check_circle
  </mat-icon>
  }
</div>
